import { checkAPIResponse } from "../../Utils/APIResponseUtils";
import apiService from "../../Services/APIService";

// API for verifying mobile number
export const verifyMobile = async (mobile, cc = "91", isResend = false) => {
  try {
    let verifyUserObj = {
      mobile,
      cc,
      isResend,
      changeType: "ADD"
    };

    const result = await apiService.accessGetData(4, 'sendUsrOTP', verifyUserObj);
    return result;
  } catch (error) {
    console.error('Error verifying mobile:', error);
    throw error;
  }
};

// API for saving user
export const saveUser = async (userData) => {
  try {
    const result = await apiService.sendChange(4, 'set', userData);
    checkAPIResponse(result);
    return result;
  } catch (error) {
    console.error('Error saving user:', error);
    throw error;
  }
};

// API for transferring assignments
export const transferAssignmentAPI = async (data) => {
  try {
    let payload = {
      changeType: data.changeType,
      fromUserID: data.fromUserID,
      toUserID: data.toUserID,
      pin: data.pin
    }
    const result = await apiService.sendChange(4, 'xfrAsgns', payload);
    return result;
  }
  catch(error){
    console.error('Error verifying mobile:', error);
    throw error;
  }
}

// Get efforts log
export const getEffortsLogAPI = async (param) => {
  try {
    const result = await apiService.getData(4, "getSalesEfforts", param);
    return result;
  }
  catch(error){
    console.error('Error verifying mobile:', error);
    throw error;
  }
}

// Set User Targets
export const setUserTargetAPI = async (data) => {
  try {
    let payload = [{
		updateType: '',
		key:'',
        changeType: data.changeType,
	    targets: JSON.stringify(data.target)
    }]

    const result = await apiService.sendChange(4, 'profile', payload);
    return result;
  }
  catch(error){
    console.error('Error setting a target:', error);
    throw error;
  }
}

// Respond to agency invitation
export const respondInvitationAPI = async (data) => {
  try {
    const payload = [{
      agencyID: data.agencyID,
      action: data.action, // 'ACCEPT' or 'REJECT'
      mobile: data.mobile || '',
      cc: data.cc || '91',
      password: data.password || ''
    }];
    const result = await apiService.accessGetData(1, 'respondInvitation', payload);
    return result;
  } catch (error) {
    console.error('Error responding to invitation:', error);
    throw error;
  }
};